<template>
    <div>
        <h2 class="f -a-center -gutter">
            <span>
                <editable-text :value.sync="company.name"
                               placeholder="Nom de la compagine"></editable-text>
            </span>
            <button class="btn btn-primary btn-sm"
                    @click.prevent="addType">
                <i class="glyphicon glyphicon-plus"></i>
                Ajouter un type de contrat
            </button>

            <span class="btn btn-info btn-sm"
                  v-if="loading">
                <loader></loader>
            </span>

            <div class="f -inline -gutter-small -a-center"
                 v-if="changed && !loading">
                <button class="btn btn-success btn-sm"
                        @click="save"
                        :class="valid ? '' : 'disabled'">
                    <i class="glyphicon glyphicon-ok"></i>
                </button>
                <button class="btn btn-danger btn-sm"
                        @click="cancel">
                    <i class="glyphicon glyphicon-remove"></i>
                </button>
            </div>
        </h2>

        <table class="table table-striped">
            <tr>
                <th>Type</th>
                <th>Min</th>
                <th>Max</th>
                <th>Cadre</th>
                <th>Type AS</th>
            </tr>

            <tr v-for="type of company.types">
                <td><editable-text :value.sync="type.name"></editable-text></td>
                <td>
                    <editable-number :value.sync="type.as_min"
                                     placeholder="Aucun"></editable-number>
                </td>
                <td>
                    <editable-number :value.sync="type.as_max"
                                     placeholder="Aucun"></editable-number>
                </td>
                <td>
                    <editable-choice :options="frameworks"
                                     :enable-reset="true"
                                     placeholder="Aucun"
                                     :value.sync="type.as_fw"></editable-choice>
                </td>
                <td>
                    <editable-choice :options="types"
                                     :enable-reset="true"
                                     placeholder="Aucun"
                                     :value.sync="type.as_type"></editable-choice>
                </td>
            </tr>
        </table>
    </div>
</template>

<style type="text/css" scoped>
    td:not(:first-child) {
        width: 15%;
    }
</style>

<script type="text/ecmascript-6">
    import Loader from '../Loader';
    import EditableText from '../editable/EditableText.vue';
    import EditableChoice from '../editable/EditableChoice.vue';
    import EditableNumber from '../editable/EditableNumber.vue';
    import {
        emptyType,
        activeSeedFrameworks,
        activeSeedTypes,
        update,
        create
    } from '../../api/companies';
    import {deepCopy, asyncAction, d} from '../../utils';
    import equals from 'equals';
    import {manager as msgManager} from '../../messages';

    export default {
        components: {
            Loader,
            EditableText,
            EditableChoice,
            EditableNumber
        },
        props: {
            company: {
                required: true,
                twoWay: true
            }
        },
        data() {
            return {
                frameworks: activeSeedFrameworks(),
                types: activeSeedTypes(),
                companyBackup: undefined,
                loading: false
            };
        },
        computed: {
            changed() {
                if (this.backupIsBlank) {
                    return true;
                }

                if (this.companyBackup) {
                    return !equals(this.company, this.companyBackup);
                }
            },
            valid() {
                if (!this.company.name) {
                    return false;
                }

                return !this.company.types.some((t) => !t.name);
            },
            backupIsBlank() {
                return !d(() => this.companyBackup.name) &&
                    !d(() => this.company.companyBackup.length);
            }
        },
        methods: {
            addType() {
                this.company.types.push(emptyType());
            },
            backup() {
                this.companyBackup = deepCopy(this.company);
            },
            restore() {
                this.company = deepCopy(this.companyBackup);
            },
            cancel() {
                if (this.backupIsBlank) {
                    this.$dispatch('reset-to-blank', this.company);
                }

                this.restore();
            },
            save: asyncAction('loading', async function () {
                this.company.types.forEach((type) => {
                    ['min', 'max'].forEach((x) => {
                        if (typeof type[`as_${x}`] !== 'number') {
                            type[`as_${x}`] = null;
                        }
                    });

                    if (!type.as_fw) {
                        type.as_fw = null;
                    }

                    if (!type.as_type) {
                        type.as_type = '';
                    }
                });

                if (this.company.id) {
                    this.company = await update(this.company);
                } else {
                    this.company = await create(this.company);
                }
                this.backup();

                msgManager.push(
                    'Succès.',
                    'La compagnie et ses types de documents sont sauvegardés',
                    'success'
                );
            })
        },
        ready() {
            this.backup();
        }
    };
</script>



// WEBPACK FOOTER //
// CompanyBlock.vue?80d7bf6c